var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2785_517)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E1C300"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C8.68548 6 6 8.68548 6 12C6 15.3145 8.68548 18 12 18C15.3145 18 18 15.3145 18 12C18 8.68548 15.3145 6 12 6ZM12.8177 9.9121L14.7532 8.75081C15.0339 8.58387 15.3339 8.9371 15.1258 9.18629L14.3129 10.1613L15.1258 11.1363C15.3363 11.3879 15.0315 11.7363 14.7532 11.5718L12.8177 10.4105C12.6315 10.2968 12.6315 10.0258 12.8177 9.9121ZM8.87419 9.18629C8.66613 8.9371 8.96613 8.58387 9.24677 8.75081L11.1823 9.9121C11.371 10.0258 11.371 10.2968 11.1823 10.4105L9.24677 11.5718C8.96855 11.7363 8.66613 11.3879 8.87419 11.1363L9.6871 10.1613L8.87419 9.18629ZM15.6508 13.2097C15.4355 14.9274 13.9694 16.2581 12.1935 16.2581H11.8065C10.0306 16.2581 8.56452 14.9274 8.34919 13.2097C8.32016 12.9798 8.50161 12.7742 8.73387 12.7742H15.2661C15.4984 12.7742 15.6798 12.9774 15.6508 13.2097Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2785_517",
    x: 0,
    y: 0,
    width: 24,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2785_517"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunny);
export default __webpack_public_path__ + "static/media/Funny.90ac8735e66521dfba84ca9ac90c500f.svg";
export { ForwardRef as ReactComponent };